import Modal from 'component/hoc/modal/Modal';
import React, { useRef, useState } from 'react';
import styles from './ManageMembersModal.module.scss';
import RoundedTabs from 'component/atom/Tabs/RoundedTabs';
import MembersList from './members-list/MembersList';
import AddUsers from './add-users/AddUsers';
import Tab from 'component/molecules/Tab/TabComponent';
import UsersList from './users-list/UsersList';

const ManageMembersModal = ({ isOpen, onClose, setRefetch, refetch, item }) => {
  const formRef = useRef();

  const [tabsKey, setTabsKey] = useState(0);

  const tabs = [
    { label: 'Members', content: <MembersList groupId={item} /> },
    { label: 'Add Existing', content: <UsersList groupId={item} /> },
    {
      label: 'Add Users',
      content: (
        <AddUsers
          ref={formRef}
          onClose={onClose}
          onSuccess={() => setTabsKey((k) => k + 1)}
          groupId={item}
          refetch={refetch}
          setRefetch={setRefetch}
        />
      ),
    },
  ];

  return (
    <Modal
      title={item?.groupName}
      isOpen={isOpen}
      onClose={onClose}
      classname={styles['modal-container']}
      modalContent={{
        component: <Tab tabs={tabs} />,
      }}
      onSubmit={() => formRef.current?.handleSubmit?.()}
      showSubmit={false}
      showCancel={false}
    />
  );
};

export default ManageMembersModal;
